import type { MouseEventHandler } from 'react';
import React from 'react';
import type { FeatureView, GetLabel } from '../types/feature';

type OptionProps = {
	getLabel: GetLabel;
	view: FeatureView;
	handleChange: MouseEventHandler<HTMLLIElement>;
};

interface ViewOption {
	value: FeatureView;
	label: string;
	classes: string;
}

export default function Option({ getLabel, view, handleChange }: OptionProps) {
	const options: ViewOption[] = [
		{
			value: 'grid',
			label: getLabel('layout_grid'),
			classes: 'option' + (view === 'grid' ? ' selected' : ''),
		},
		{
			value: 'list',
			label: getLabel('layout_list'),
			classes: 'option' + (view === 'list' ? ' selected' : ''),
		},
	];

	const getOption = (option: ViewOption) => {
		return (
			<li className={option.classes} onClick={handleChange}>
				<span>{option.label}</span>
			</li>
		);
	};

	return (
		<div className="feature__controls--option">
			<ul className="mcfly-options mcfly-options--small" data-value={view}>
				{options.map((option, index) => (
					<React.Fragment key={index}>{getOption(option)}</React.Fragment>
				))}
			</ul>
		</div>
	);
}
